module.exports = __webpack_public_path__ + "static/Apple iPhone 8 Silver-075b91d8bb7cb8ee318652b33bdc99ec.webp";